import type { useAgentSessionsLiveUpdatesSubscription as Subscription } from './__generated__/useAgentSessionsLiveUpdatesSubscription.graphql';
import type { AgentSessionsLiveEvent } from './observeAgentSessionsLiveEvents';

const nonBlank = (value: string | null | undefined): string | undefined => {
	const trimmed = value?.trim();
	return trimmed ? trimmed : undefined;
};

export const getAgentSessionsLiveEvent = (
	response: Subscription['response'] | null | undefined,
): AgentSessionsLiveEvent | null => {
	const change = response?.convoai_onInboxSessionChanged;
	if (change == null) return null;
	const readStatus = change.session?.conversationChannel?.readStatus;

	return {
		conversationId: nonBlank(change.session?.conversationChannel?.id),
		...(typeof readStatus === 'boolean' ? { readStatus } : {}),
	};
};
